import { type ObjectDataShape } from '@capsicum/socios-core';
import { z } from 'zod';

const DEFAULT_WIDTH = 0;
const DEFAULT_HEIGHT = 0;

const parsers: Array<
	(info: ObjectDataShape) =>
		| {
				blurHash?: string;
				height: number;
				url: string;
				width: number;
		  }
		| undefined
> = [
	(dataObject: ObjectDataShape) => {
		const info = z
			.object({
				images: z
					.array(
						z.object({
							blurHash: z.string().or(z.null()).optional(),
							height: z.number().int().default(DEFAULT_HEIGHT).optional(),
							url: z.string(),
							width: z.number().int().default(DEFAULT_WIDTH).optional()
						})
					)
					.min(1)
			})
			.safeParse(dataObject);

		if (!info.success) return;

		const details = info.data.images[0]!; // Cannot be undefined else Zod will complain.

		return {
			height: details.height || DEFAULT_HEIGHT,
			url: details.url,
			width: details.width || DEFAULT_WIDTH
		};
	},

	(dataObject: ObjectDataShape) => {
		const info = z
			.object({
				image: z.object({
					large: z.object({
						h: z.number().int().default(DEFAULT_HEIGHT).optional(),
						url: z.string(),
						w: z.number().int().default(DEFAULT_WIDTH).optional()
					})
				})
			})
			.safeParse(dataObject);

		if (!info.success) return;

		const details = info.data.image.large!;

		return {
			height: details.h || DEFAULT_HEIGHT,
			url: details.url,
			width: details.w || DEFAULT_WIDTH
		};
	},

	(dataObject: ObjectDataShape) => {
		const info = z
			.object({
				images: z.object({
					image: z.object({
						large: z.object({
							h: z.number().int().default(DEFAULT_HEIGHT).optional(),
							url: z.string(),
							w: z.number().int().default(DEFAULT_WIDTH).optional()
						})
					})
				})
			})
			.safeParse(dataObject);

		if (!info.success) return;

		const details = info.data.images.image.large;

		return {
			height: details.h || DEFAULT_HEIGHT,
			url: details.url,
			width: details.w || DEFAULT_WIDTH
		};
	}
];

export const parseImageFromFeedObject = (dataObject?: ObjectDataShape) => {
	if (dataObject) {
		for (let index = 0; index < parsers.length; index++) {
			const parser = parsers[index];

			if (!parser) continue;

			const info = parser(dataObject);

			if (!info) continue;

			return info;
		}
	}

	return {
		height: DEFAULT_HEIGHT,
		url: undefined,
		width: DEFAULT_WIDTH
	};
};
